export function createEnumFromObjectValues<T extends Record<string, string>>(obj: T) {
  // Values are a union of all the string literals
  type Value = T[keyof T];
  const values = Object.values(obj) as Value[];
  // Force non-empty tuple
  return values as [Value, ...Value[]];
}

// a new function to create enum from a const array
export function createEnumFromArray<T extends string>(arr: T[]) {
  return arr as [T, ...T[]];
}
